import { ID } from '@datorama/akita';
import { IEntitlement } from '../models';

export class Entitlement implements IEntitlement {
  id: ID;
  createdAt: Date;
  modifiedAt: Date;
  createdBy: string;
  modifiedBy: string;
  userRoleId: string;
  privilegeId: ID;

  constructor(
    role: IEntitlement = {
      id: '',
      createdAt: new Date(),
      modifiedAt: new Date(),
      createdBy: '',
      modifiedBy: '',
      userRoleId: '',
      privilegeId: '',
    }
  ) {
    const {
      createdAt,
      modifiedAt,
      createdBy,
      modifiedBy,
      userRoleId,
      privilegeId,
    } = role;

    this.createdAt = createdAt;
    this.modifiedAt = modifiedAt;
    this.createdBy = createdBy;
    this.modifiedBy = modifiedBy;
    this.userRoleId = userRoleId;
    this.privilegeId = privilegeId;
  }
}
